var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1875 2.26562C0.1875 1.23438 1.02539 0.375 2.07812 0.375H9.29688H9.8125V0.890625V8.45312V8.96875H9.29688H9.125V10.3438H9.29688H9.8125V11.375H9.29688H1.90625C0.939453 11.375 0.1875 10.623 0.1875 9.65625C0.1875 9.61328 0.1875 9.54883 0.1875 9.48438V2.26562ZM1.90625 8.96875C1.51953 8.96875 1.21875 9.29102 1.21875 9.65625C1.21875 10.043 1.51953 10.3438 1.90625 10.3438H8.09375V8.96875H1.90625ZM1.21875 8.08789C1.41211 8.00195 1.64844 7.9375 1.90625 7.9375H8.78125V1.40625H2.07812C1.58398 1.40625 1.21875 1.79297 1.21875 2.26562V8.08789ZM3.45312 2.78125H7.23438H7.75V3.8125H7.23438H3.45312H2.9375V2.78125H3.45312ZM3.45312 4.5H7.23438H7.75V5.53125H7.23438H3.45312H2.9375V4.5H3.45312Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.9bd64c2ac73b3737189d8edfc37a3c8c.svg";
export { ForwardRef as ReactComponent };